import React from 'react'
import { Grid, PageSection as Section } from '@superhi/design'

import TestimonialCard from './components/TestimonialCard'
import { Desktop, Mobile, Content, Cell3, Cell1, Cell2 } from './styles'

import BackgroundImageWarped from 'src/components/BackgroundImageWarped'

const DATA: React.ComponentProps<typeof TestimonialCard>[] = [
  {
    imageUrl:
      'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/community-avatars/jade-m.png',
    text: 'Even after finishing my course I still receive support from the community and SuperHi staff. I’ve learned so much from the courses in general, but there’s so much more offered that has been beneficial to my career and development.',
    authorName: 'Jade M',
    authorLocation: 'Columbus, USA',
  },
  {
    imageUrl:
      'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/community-avatars/neils-k.png',
    text: "The biggest plus has been the community and the fact that I can get help quickly if I'm stuck. Another plus is the inspirational aspect, sharing notes and connecting with other students.",
    authorName: 'Niels K',
    authorLocation: 'London, UK',
  },
  {
    imageUrl:
      'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/community-avatars/amy-l.png',
    text: "SuperHi not only jumpstarted my career in design but also provided me with a community that inspires and supports me every day. Joining SuperHi has been the best investment I've made!",
    authorName: 'Amy L',
    authorLocation: 'NYC, USA',
  },
  {
    imageUrl:
      'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/community-avatars/silja-w.png',
    text: 'The online community of students and teachers is incredibly supportive and responsive. It’s taught me the skills I need to transition to working as a frontend developer, and create projects and sites that I love.',
    authorName: 'Silja W',
    authorLocation: 'Montreal, Canada',
  },
  {
    imageUrl:
      'https://superhi.s3.amazonaws.com/assets/images/unlimited-membership/community-avatars/jennifer-g.png',
    text: "I keep coming back to SuperHi even when I'm not taking a course. SuperHi is an affordable option compared to bootcamps and the only online learning experience I found that has a genuine community of people that are active and involved.",
    authorName: 'Jennifer G',
    authorLocation: 'NYC, USA',
  },
]

const DATA_REST = DATA.slice(1)

type Props = {
  title?: string
  subtitle?: string
  borders?: boolean
}

export const CommunityContent: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  subtitle,
  borders,
}) => (
  <Section title={title} subtitle={subtitle} subtitleMaxWidth={36} headingLevel={2}>
    <Desktop>
      <Grid>
        <Grid.Cell span="full">
          <Content>
            <Cell1>
              <TestimonialCard {...DATA[0]} level="1" border={borders} />
            </Cell1>
            <Cell2>
              {DATA_REST.map((data, dataIndex) => (
                <Cell3 key={dataIndex}>
                  <TestimonialCard {...data} border={borders} />
                </Cell3>
              ))}
            </Cell2>
          </Content>
        </Grid.Cell>
      </Grid>
    </Desktop>

    <Mobile>
      <Grid slider={{ small: true }} alignItems="stretch">
        <Grid.Cell span={{ small: 3, medium: 'full' }}>
          <TestimonialCard {...DATA[0]} level="1" border={borders} />
        </Grid.Cell>
        {DATA_REST.map((data, dataIndex) => (
          <Grid.Cell key={dataIndex} span={{ small: 3, medium: 4 }}>
            <TestimonialCard {...data} border={borders} />
          </Grid.Cell>
        ))}
      </Grid>
    </Mobile>
  </Section>
)

const BACKGROUND_IMAGE_OPTIONS: React.ComponentProps<typeof BackgroundImageWarped>['options'] = {
  small: {
    ar: '50:100',
    fit: 'crop',
    crop: 'bottom',
  },
  medium: {
    ar: '50:100',
    fit: 'crop',
    crop: 'bottom',
  },
  large: {
    ar: '100:100',
    fit: 'crop',
    crop: 'bottom',
  },
  xlarge: {
    ar: '125:100',
    fit: 'crop',
    crop: 'bottom',
  },
}

const Community: React.FC<React.PropsWithChildren<Props>> = (props) => (
  <BackgroundImageWarped color="yellow" position="top center" options={BACKGROUND_IMAGE_OPTIONS}>
    <CommunityContent {...props} />
  </BackgroundImageWarped>
)
export default Community
